<template>
  <div class="ibox">
    <div class="ibox-title">
      Login
      <span class="float-right" @click="showContent = !showContent" style="cursor: pointer">
            <EyeIcon v-if="showContent" />
            <EyeOffIcon v-else/>
      </span>
    </div>
    
    <div class="ibox-content" v-show="showContent">
      <div class="row">
        <div class="col-md-3">
          <span class="float-right">Login</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.login"
                 :disabled="login.id"
                 class="form-control"
          >
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right ml-2" v-if="login.hasPassword">
            <CheckIcon class="with-password" v-tooltip.down="'Senha já cadastrada'"/>
          </span>
          <span class="float-right">Senha</span>
        </div>
        <div class="col-md-7">
          <input class="form-control"
                 v-model="login.password"
                 :type="showPassword ? 'text' : 'password'"
          >
          <i class="eye-password" @click="showPassword = !showPassword"
             :title="showPassword ? 'Ocultar Senha' : 'Mostrar Senha'">
            <EyeIcon v-if="showPassword" />
            <EyeOffIcon v-else/>
          </i>
        </div>
      </div>
  
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right ml-2">
            <AlertCircleIcon v-tooltip.down="'Quando ativo irá buscar as notas no DF-e.'"/>
          </span>
          
          <span class="float-right">Ativo</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.active"
                 type="checkbox"
          >
        </div>
      </div>
  
      <hr>
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right">Última Data</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.setting.lastDate"
                 class="form-control"
          >
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right">Quantidade por página</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.setting.perPage"
                 class="form-control"
                 type="number"
          >
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right ml-2" v-if="login.setting && login.setting.hasPlatformToken">
            <CheckIcon class="with-password" v-tooltip.down="'Token já cadastrado'"/>
          </span>
  
          <span class="float-right ml-2" v-else>
            <AlertCircleIcon v-tooltip.down="'Token do usuário.'"/>
          </span>
          
          <span class="float-right">token</span>
        </div>
        <div class="col-md-7">
          <input class="form-control"
                 v-model="login.setting.platformToken"
                 :type="showPassword ? 'text' : 'password'"
          >
          <i class="eye-password" @click="showPassword = !showPassword"
             :title="showPassword ? 'Ocultar Senha' : 'Mostrar Senha'">
            <EyeIcon v-if="showPassword" />
            <EyeOffIcon v-else/>
          </i>
        </div>
      </div>
  
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right">Página</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.setting.page"
                 class="form-control"
          >
        </div>
      </div>
      
      <div class="row mt-3">
        <div class="col-md-3">
          <span class="float-right">Próxima iteração</span>
        </div>
        <div class="col-md-7">
          <input v-model="login.setting.nextSearch"
                 disabled="true"
                 class="form-control"
          >
        </div>
      </div>
  
      <div class="row mt-3" v-if="showErrors">
        <div class="col-md-3">
          <span class="float-right"><b style="color: red">Erros</b></span>
        </div>
        <div class="col-md-7">
          <textarea :value="login.setting.lastErrors.join('\n')"
                    class="form-control"
                    disabled="true"
                    :rows="login.setting.lastErrors.length"
          />
        </div>
      </div>
  
      <hr>
      <div class="row mt-3">
        <div class="col-md-12 text-center">
          <button v-if="login.id" @click="reload" class="btn btn-outline btn-large mr-3">
            Atualizar
          </button>
          
          <button @click="save" class="btn btn-primary btn-large">
            Salvar
          </button>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
  import { AlertCircleIcon, CheckIcon, EyeIcon, EyeOffIcon } from 'vue-feather-icons'
  import ModelMapper from '@/mixins/ModelMapper'
  
  export default {
    components: { AlertCircleIcon, CheckIcon, EyeIcon, EyeOffIcon },
    computed: {
      showErrors() {
        return Array.isArray(this.login.setting.lastErrors) && this.login.setting.lastErrors.length > 0
      }
    },
    created() {
      this.login = this.buildLogin()
      
      this.reload()
    },
    data: () => ({
      login: null,
      modelPathPrefix: 'unico_integration',
      nameModel: 'Login',
      showContent: true,
      showPassword: false
    }),
    methods: {
      buildLogin() {
        return {
          active: true,
          setting: {
            perPage: 10
          }
        }
      },
      reload() {
        this.openLoad()
        
        this.axios.get('/unico_integration/logins/current')
          .then(response =>  {
            if (response.data)
              this.login = this.$parse.toCamelcase(response.data)
            else
              this.login = this.buildLogin()
          })
          .finally(() => this.closeLoad())
      },
      save() {
        this.asyncTemplateSave(this.login, {
          after: ({model}) => {
            this.login = model
            this.$notify.add('Login salvo com sucesso!')
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Login',
    watch: {
      login(value) {
        const load = value && typeof value === 'object' && value.id
        this.$emit('login', load)
      }
    }
  }
</script>

<style scoped>
  .eye-password {
    cursor: pointer;
    position: absolute;
    right: 20px;
    bottom: 6px;
  }
  
  .with-password {
    color: green
  }
</style>